import { badgeCommonTrackingModule } from '../common/di'

export const badgeScorm2004TrackingModules = [
  badgeCommonTrackingModule
]
